(function ($) {
    var $toggleNewAddress = $('[data-radio-toggle]');
    var $paymentTabs = $('[data-payment-tab]');
    var $payLater = $('[data-pay-later]');
    var $noPaymentRequired = $('[data-no-payment-required]');
    var $countrySelect = $('[data-country-select]');
    var $newAddressForm = $('[data-new-address-form]');

    if($toggleNewAddress.length > 0) {
        for (var i = 0; i < $toggleNewAddress.length; i++) {
            if($($($toggleNewAddress[i]).find('input'))[0].checked) {
                setHiddenFields($($toggleNewAddress[i]));
            }
        }
        var toggleClass = 'new-billing-form--active';
        $toggleNewAddress.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if($(this).attr('data-target')) {
                $(this).attr('aria-expanded', 'true');
                $($(this).data('target')).attr('aria-hidden', 'false');
                $($(this).data('target')).show('fast');
                $($(this).data('target')).addClass(toggleClass);
            } else {
                for (i = 0; i < $toggleNewAddress.length; i++) {
                    if(typeof $($toggleNewAddress[i]).attr('aria-expanded') !== 'undefined') {
                        $($toggleNewAddress[i]).attr('aria-expanded', 'false');
                    }
                }
                $('.' + toggleClass).attr('aria-hidden', 'true');
                $('.' + toggleClass).hide('fast');
            }
            $(this).find('input').prop('checked', true);
            setHiddenFields($(this));
        });
    }
    if($paymentTabs.length > 0) {
        var $paymentPages = $('[data-payment-page]');
        $paymentTabs.on('click', function () {
            $paymentTabs.removeClass('selected');
            $paymentTabs.attr('aria-expanded', 'false');
            $(this).addClass('selected');
            $(this).attr('aria-expanded', 'true');
            if($paymentPages.length > 0) {
                $paymentPages.attr('aria-hidden', 'true');
                $paymentPages.removeClass('selected');
                $($(this).data('target')).addClass('selected');
                $($(this).data('target')).attr('aria-hidden', 'false');
            }
        });
    }
    $payLater.on('click', function () {
        var payLaterModel = {};
        payLaterModel[$('#thankyouPageUrl').attr('name')] = $('#thankyouPageUrl').val();
        payLaterModel['PayLater'] = true;
        loadPayLaterAPI(payLaterModel);
    });
    $noPaymentRequired.on('click', function () {
        var payLaterModel = {};
        payLaterModel['PayLater'] = false;
        loadNoPaymentRequiredAPI(payLaterModel);
    });
    var countryModel = {};
    if(!($countrySelect.val() === '')) {
        countryModel['CountryCode'] = $countrySelect.val();
        loadStates(countryModel);
    }
    $countrySelect.change(function () {
        countryModel['CountryCode'] = $(this).val();
        loadStates(countryModel);
    });
    $newAddressForm.on('submit', function () {
        // remove disable on state field if needed to add to post back
        $('#states').prop('disabled', false);
    });
}(jQuery));

function setHiddenFields($el) {
    var $fields = $el.find('[data-property]');
    var existingAddressModel = {};
    for (var i = 0; i < $fields.length; i++) {
        existingAddressModel[$($fields[i]).data('property')] = $($fields[i]).text();
    }
    var $hiddenFields = $('[data-property-input]');
    if($hiddenFields.length > 0) {
        if($el.find('input').val() === 'ExistingAddress') {
            for (i = 0; i < $hiddenFields.length; i++) {
                $($hiddenFields[i]).attr('value', existingAddressModel[$($hiddenFields[i]).attr('name')]);
            }
        } else {
            for (i = 0; i < $hiddenFields.length; i++) {
                if($($hiddenFields[i]).attr('name') === 'IsExisting') {
                    $($hiddenFields[i]).val('false');
                }
            }
        }
    }
}

function loadPayLaterAPI(data) {
    var $error = $('[data-paylater-error]');
    $error.hide();
    $error.empty();
    var url = 'api/checkout/PayLaterAndSubmitOrder';
    $('[data-checkout-loading]').overlay();
    setTimeout(() => {
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: (response) => {
                /* eslint-disable */
                if(response.Success || response.Success === 'true') {
                    window.open(response.ReturnUrl, '_self');
                    $('[data-checkout-loading]').overlay();
                } else {
                    window.open(response.ReturnUrl, '_self');
                    $('[data-checkout-loading]').overlay();
                }
                /* eslint-enable */
            },
            error: (xhr, status, error) => {
                $('[data-checkout-loading]').overlay();
                if($error.length > 0) {
                    $error.show();
                    $error.append('<p><span class="h-http-error__accent">Uh oh, there was a problem loading your data.</span><br>If the problem persists, please contact us to resolve the error.</p>');
                    console.log(xhr.status);
                }
            }
        });
    }, 1000);
}

function loadNoPaymentRequiredAPI(data) {
    var $error = $('[data-paylater-error]');
    $error.hide();
    $error.empty();
    var url = 'api/checkout/ApplyZeroPaymentAndSubmitOrder';
    $('[data-checkout-loading]').overlay();
    setTimeout(() => {
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: (response) => {
                /* eslint-disable */
                if(response.Success || response.Success === 'true') {
                    window.open(response.ReturnUrl, '_self');
                    $('[data-checkout-loading]').overlay();
                } else {
                    window.open(response.ReturnUrl, '_self');
                    $('[data-checkout-loading]').overlay();
                }
                /* eslint-enable */
            },
            error: (xhr, status, error) => {
                $('[data-checkout-loading]').overlay();
                if($error.length > 0) {
                    $error.show();
                    $error.append('<p><span class="h-http-error__accent">Uh oh, there was a problem loading your data.</span><br>If the problem persists, please contact us to resolve the error.</p>');
                    console.log(xhr.status);
                }
            }
        });
    }, 1000);
}

function loadStates(data) {
    var $stateSelect = $('[data-state-select]');
    $stateSelect.empty();
    /* eslint-disable */
    ConferenceRegistrationProfile.checkStateValidation($stateSelect, data.CountryCode, false);
    /* eslint-enable */
    $stateSelect.parent().find('.c-spinner').show();
    $stateSelect.parent().find('.label-text').hide();
    if($stateSelect.length > 0) {
        var url = '/api/checkout/GetSubdivisions';
        setTimeout(() => {
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                success: (response) => {
                    var selected = '';
                    if(Object.keys(response.States).length === 1) {
                        selected = 'selected';
                    } else {
                        $stateSelect.append('<option selected></option>');
                    }

                    for (var state in response.States) {
                        $stateSelect.append('<option ' + selected + ' value="' + state + '">' + response.States[state] + '</option>');
                    }
                    $stateSelect.parent().find('.c-spinner').hide();
                    $stateSelect.parent().find('.label-text').show();
                },
                error: (xhr, status, error) => {
                    console.log(xhr.status);
                    $stateSelect.parent().find('.c-spinner').hide();
                    $stateSelect.parent().find('.label-text').show();
                }
            });
        }, 250);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/checkout/checkout.js